import React from 'react';

/**
 * Mobile Opponent Preparation Bonus and Diplomatic Accord Component
 * Positioned to the left of opponent drone zone
 */
export const MobileOpponentBonuses = ({
  gameState,
  userId,
  opponentPreparationBonus,
  opponentDiplomaticAccord,
  t
}) => {
  const currentOpponentId = gameState?.players?.find(id => id !== userId);
  const currentOpponent = currentOpponentId ? gameState?.state?.[currentOpponentId] : null;
  const opponentGoesSecond = currentOpponentId && gameState?.players?.[1] === currentOpponentId;
  const shouldShowPrepBonus = opponentGoesSecond && 
                     opponentPreparationBonus && 
                     (opponentPreparationBonus === 'plan_ahead' || opponentPreparationBonus === 'black_market' || opponentPreparationBonus === 'team_leader');
  
  if (!shouldShowPrepBonus && !opponentDiplomaticAccord) return null;
  
  return (
    <div
      className="opponent-bonuses-mobile"
      style={{
        position: "absolute",
        top: "5px",
        right: "125px",
        zIndex: 1002,
        display: "flex",
        gap: "2px",
        flexDirection: "row",
        transform: "scale(0.35)",
        transformOrigin: "top right"
      }}
    >
      {/* Opponent Preparation Bonus */}
      {shouldShowPrepBonus && currentOpponent && (
        <div 
          style={{ 
            width: "84px",
            height: "84px"
          }}
          data-tooltip={
            currentOpponent.preparationBonusUsed === true ? (t('battleUI.preparationBonusUsed') || 'Preparation bonus already used') :
            opponentPreparationBonus === 'plan_ahead' ? t('profile.preparationBonus.planAhead') :
            opponentPreparationBonus === 'black_market' ? t('profile.preparationBonus.blackMarketDossier') :
            t('profile.preparationBonus.teamLeaderMeeting')
          }
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              border: "2px solid rgba(255, 255, 255, 0.2)",
              borderRadius: "8px",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
              margin: 0,
              ...(currentOpponent.preparationBonusUsed === true ? {
                filter: 'grayscale(100%)',
                background: 'rgba(30, 30, 30, 0.7)',
                opacity: 0.7
              } : {
                background: 'rgba(50, 50, 50, 0.5)',
                filter: 'none',
                opacity: 1
              })
            }}
          >
            <img 
              src={`/images/${opponentPreparationBonus === 'plan_ahead' ? 'plan_ahead.jpg' : 
                            opponentPreparationBonus === 'black_market' ? 'black_market_dossier.jpg' : 
                            'team_leader_briefing.jpg'}`}
              alt={opponentPreparationBonus}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                pointerEvents: "none"
              }}
            />
          </div>
        </div>
      )}
      
      {/* Opponent Diplomatic Accord */}
      {opponentDiplomaticAccord && (
        <div 
          style={{ 
            width: "84px",
            height: "84px"
          }}
          data-tooltip={
            opponentDiplomaticAccord === 'strategic_coordination' ? t('profile.diplomaticAccords.strategicCoordination') :
            opponentDiplomaticAccord === 'public_relations' ? t('profile.diplomaticAccords.publicRelations') :
            opponentDiplomaticAccord === 'emergency_protocol' ? t('profile.diplomaticAccords.emergencyProtocol') :
            t('profile.diplomaticAccords.commandDirective')
          }
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              border: "2px solid rgba(255, 255, 255, 0.2)",
              borderRadius: "8px",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
              margin: 0,
              background: 'rgba(50, 50, 50, 0.5)'
            }}
          >
            <img 
              src={`/images/${opponentDiplomaticAccord === 'strategic_coordination' ? 'strategic_coordination.jpg' : 
                            opponentDiplomaticAccord === 'public_relations' ? 'public_relations.jpg' : 
                            opponentDiplomaticAccord === 'emergency_protocol' ? 'emergency_protocol.jpg' : 
                            'command_directive.jpg'}`}
              alt={opponentDiplomaticAccord}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                pointerEvents: "none"
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileOpponentBonuses;

